import React from 'react';
import { Box, Button, CssBaseline, Paper, Popper, Tooltip, Typography, Grid } from '@mui/material';
import {
    DataGrid,
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridToolbarExport,
    GridToolbarDensitySelector
} from '@mui/x-data-grid';
import Container from '@mui/material/Container';
import AddCircleOutlineRoundedIcon from '@mui/icons-material/AddCircleOutlineRounded';
import FullScreenDialog from "../../../../Components/CustomDialogs/Fullscreendialog"
import Addreport from './Components/Addreport';
import axios from 'axios';
import { genpostURL, genpostURLTEST, genURL, genURLTEST } from '../../../../_getjson';
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import PlaylistAddRoundedIcon from '@mui/icons-material/PlaylistAddRounded';
import PropTypes from 'prop-types';
import EditOptionreport from './Components/EditOptionreport';
import Confirmdialog from '../../../../Components/CustomDialogs/Confirmdialog';
import CustomSnackbar from '../../../../Components/Snackbar/Snackbar';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';


function isOverflown(element) {
    return (
        element.scrollHeight > element.clientHeight ||
        element.scrollWidth > element.clientWidth
    );
}
const GridCellExpand = React.memo(function GridCellExpand(props) {
    const { width, value } = props;
    const wrapper = React.useRef(null);
    const cellDiv = React.useRef(null);
    const cellValue = React.useRef(null);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [showFullCell, setShowFullCell] = React.useState(false);
    const [showPopper, setShowPopper] = React.useState(false);

    const handleMouseEnter = () => {
        const isCurrentlyOverflown = isOverflown(cellValue.current);
        setShowPopper(isCurrentlyOverflown);
        setAnchorEl(cellDiv.current);
        setShowFullCell(true);
    };

    const handleMouseLeave = () => {
        setShowFullCell(false);
    };

    React.useEffect(() => {
        if (!showFullCell) {
            return undefined;
        }

        function handleKeyDown(nativeEvent) {
            // IE11, Edge (prior to using Bink?) use 'Esc'
            if (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc') {
                setShowFullCell(false);
            }
        }

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [setShowFullCell, showFullCell]);

    return (
        <Box
            ref={wrapper}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            sx={{
                alignItems: 'center',
                lineHeight: '24px',
                width: '100%',
                height: '100%',
                position: 'relative',
                display: 'flex',
            }}
        >
            <Box
                ref={cellDiv}
                sx={{
                    height: '100%',
                    width,
                    display: 'block',
                    position: 'absolute',
                    top: 0,
                }}
            />
            <Box
                ref={cellValue}
                sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontFamily: "Customfont !important", }}
            >
                {value}
            </Box>
            {showPopper && (
                <Popper
                    open={showFullCell && anchorEl !== null}
                    anchorEl={anchorEl}
                    style={{ width, marginLeft: -17 }}
                >
                    <Paper
                        elevation={1}
                        style={{ minHeight: wrapper.current.offsetHeight - 3 }}
                    >
                        <Typography variant="body2" style={{ padding: 8 }} sx={{
                            fontFamily: "Customfont !important", whiteSpace: 'normal', wordBreak: "break-word"
                        }}>
                            {value}
                        </Typography>
                    </Paper>
                </Popper>
            )}
        </Box>
    );
});

GridCellExpand.propTypes = {
    value: PropTypes.string.isRequired,
    width: PropTypes.number.isRequired,
};

function renderCellExpand(params) {
    return (
        <GridCellExpand value={params.value || ''} width={params.colDef.computedWidth} />
    );
}

export default function eportmain() {
    const [Reloadtable, setReloadtable] = React.useState(false)
    const [rows, setRows] = React.useState([])
    const [selectionModel, setSelectionModel] = React.useState([]);

    const [opendialogModel, setOpendialogModel] = React.useState(false)
    const [titledialogModel, settitledialogModel] = React.useState(false)
    const [optionData, setOptiondata] = React.useState([])

    const [copendialog, setCopendialog] = React.useState(false)
    const [cdescriptiondialog, setCdescriptiondialog] = React.useState(false)

    //----------------------------alert ----------------------------
    const [color, setColor] = React.useState("")
    const [opensnackbar, setOpensnackbar] = React.useState(false)
    const [autoClose, setAutoClose] = React.useState(3600)
    const [messagealert, setMessagealert] = React.useState("")
    const [icon, setIcon] = React.useState("")

    const columns = [
        { field: 'id', headerName: 'ID', width: 50 },
        {
            field: 'reportnameTh',
            headerName: 'ชื่อรายงาน(TH)',
            width: 150,
            editable: true,
            flex: 1,
            renderCell: renderCellExpand,
        },
        {
            field: 'reportnameEn',
            headerName: 'ชื่อรายงาน(EN)',
            width: 150,
            editable: true,
            flex: 1,
            renderCell: renderCellExpand,
        },
        {
            field: 'URL',
            headerName: 'URL',
            width: 200,
            editable: false,
            flex: 1,
            renderCell: renderCellExpand,
        },
        {
            field: 'PSCategoryreportsubnameTh',
            headerName: 'หมวดหมู่ย่อย',
            width: 200,
            editable: false,
            flex: 1,
            renderCell: renderCellExpand,

        }
    ];
    React.useEffect(() => {
        // console.log("test reload");
        GetreportData()
        return () => {
        }
    }, [Reloadtable])

    React.useEffect(() => {
        GetreportData()
        return () => {
        }
    }, [])

    const GetreportData = async () => {
        let url = "reportmanage/report?"
        let elementreportlist = []
        console.log("GetreportData url", genURL(url));
        await axios.get(genURL(url)).then(res => {
            // await axios.post(genpostURLTEST(url), parameter).then(res => {
            console.log("GetreportData resdata report", res.data);
            if (res.data.length > 0) {
                for (let index = 0; index < res.data.length; index++) {
                    elementreportlist.push({
                        id: res.data[index].id,
                        reportnameTh: res.data[index].nameTH,
                        reportnameEn: res.data[index].nameEN,
                        URL: res.data[index].pathname,
                        PSCategoryreportsubnameTh: res.data[index].categoryreportnameTH
                    })
                }
            }
        }).catch(error => {
            console.log("resdata", error);
            // this.setState({ opensnackbar: true })
            // this.setState({ color: "warning" })
            // this.setState({ icon: ErrorIcon })
            // this.setState({ messagealert: "เกิดข้อผิดพลาด" + error })
            // this.setState({ openBackdrop: false })
        });
        await setRows(elementreportlist)
    }
    return (
        <Box sx={{
            height: 500, width: '100%'
        }}>

            <DataGrid
                sx={{
                    fontFamily: "Customfont !important",
                    // "& .MuiDataGrid-virtualScrollerRenderZone": {
                    //     "& .MuiDataGrid-row": {
                    //         "&:nth-child(2n)": { backgroundColor: "rgba(235, 235, 235, .7)", fontFamily: "Customfont !important" }
                    //     }
                    // }
                }}
                rows={rows}
                columns={columns}
                rowHeight={35}
                checkboxSelection disableSelectionOnClick
                onSelectionModelChange={(newSelectionModel) => {
                    setSelectionModel(newSelectionModel);
                }}

                editMode={false}
                components={{
                    Toolbar: CustomToolbar,
                }}
            />

        </Box >
    );

    function CustomToolbar() {
        const [openFullScreenDialog, setopenFullScreenDialog] = React.useState(false)
        const [titleFullScreenDialog, settitleFullScreenDialog] = React.useState("")
        const [typemanage, settypemanage] = React.useState("")
        const addData = () => {
            console.log("test click");
            setopenFullScreenDialog(true)
            settypemanage("addreport")
            settitleFullScreenDialog("เพิ่มรายงาน")
        }
        const CloseDialog = (e) => {
            setopenFullScreenDialog(e)
            if (typemanage === "addreport") {
                setReloadtable(!Reloadtable)
            }
        }
        const styleMenu = { color: "black" }
        const delData = async () => {
            setCopendialog(true)
            setCdescriptiondialog("คุณต้องการลบรายการนี้หรือไม่...?")

        }
        //ลบข้อมูลรายงาน
        const deleteReport = async (id) => {
            const parameterdel = new URLSearchParams();
            parameterdel.append("jwt", localStorage.getItem("Token"));

            let url = `/reportmanage/report/${id}?`
            // await axios.post(genpostURL(url), parameter).then(res => {
            await axios.post(genURL(url), parameterdel).then(res => {
                console.log("resdata", res.data.status);
                if (res.data.status === "success") {
                    setReloadtable(!Reloadtable)

                }
            }).catch(error => {
                console.log("error" + error);
            });
        }

        const OptionData = (val) => {
            setOptiondata(val)
        }
        const editOption = () => {
            console.log("selectionModel", selectionModel.length)
            if (selectionModel.length < 2) {
                setopenFullScreenDialog(true)
                settitleFullScreenDialog("เพิ่มออปชั่นรายงาน")
                settypemanage("addoption")
            } else {
                setMessagealert("ต้องเลือก 1 รายการเท่านั้น")
                setColor("warning")
                setOpensnackbar(true)
                setIcon(< InfoRoundedIcon />)
            }
        }
        const rescData = (e) => {
            if (e === "Y") {
                for (let index = 0; index < selectionModel.length; index++) {
                    console.log("selectedIDs", selectionModel[index])
                    deleteReport(selectionModel[index])
                }
            }
        }
        return (<>
            <GridToolbarContainer >
                <Tooltip describeChild title="เพิ่มรายงาน" onClick={e => addData()} style={{ cursor: "pointer" }} >
                    <AddCircleOutlineRoundedIcon />
                </Tooltip>
                <Tooltip describeChild title="ลบรายงาน" onClick={e => delData()}
                    style={{
                        cursor: "pointer",
                        display: selectionModel.length < 1 ? "none" : "block"
                    }} >
                    <DeleteOutlineRoundedIcon />
                </Tooltip>
                <Tooltip describeChild title="เพิ่มตัวเลือกรายงาน" onClick={e => editOption()}
                    style={{
                        cursor: "pointer",
                        display: selectionModel.length < 1 ? "none" : "block"
                    }}>
                    <PlaylistAddRoundedIcon />
                </Tooltip>

                |
                {/* <GridToolbarColumnsButton style={styleMenu} /> | */}
                <GridToolbarFilterButton style={styleMenu} /> |
                <GridToolbarDensitySelector style={styleMenu} /> |
                <GridToolbarExport style={styleMenu} />
            </GridToolbarContainer>
            <FullScreenDialog open={openFullScreenDialog} title={titleFullScreenDialog} CloseDialog={e => CloseDialog(e)} >
                {typemanage === "addreport" ? <Addreport CloseDialog={e => CloseDialog(e)} /> : <EditOptionreport CloseDialog={e => CloseDialog(e)} reportID={selectionModel[0]} />
                }
            </FullScreenDialog>

            <CustomSnackbar place="br"
                color={color}
                icon={icon}
                autoClose={autoClose}
                message={messagealert}
                open={opensnackbar}
                closeNotification={() => { setOpensnackbar(false) }}
                close />

            {/* open: PropTypes.bool,
            description: PropTypes.string,
            Agreetxt: PropTypes.string,
            Disagreetxt: PropTypes.string,
            title: PropTypes.string */}
            <Confirmdialog open={copendialog} description={cdescriptiondialog} Agreetxt={"ตกลง"} Disagreetxt={"ยกเลิก"} data={e => rescData(e)} title="" closedialog={e => setCopendialog(false)} />
        </>
        );
    }
}